import React, { useId } from "react";

type Props = {
    onClick: () => void;
};

export function MenuMaskClose({ onClick }: Props) {
    const uid = useId().replace(/:/g, "");
    const maskId = `sideHeaderMenuMask-${uid}`;
    const gradientId = `sideHeaderMenuSunSet-${uid}`;

    return (
        <div className="side-header-menu__mask-close">
            <svg
                className="side-header-menu__mask-close-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="242"
                viewBox="0 0 80 242"
                fill="none"
                aria-hidden="true"
            >
                <mask
                    id={maskId}
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="242"
                >
                    <rect width="80" height="242" fill="#D9D9D9" />
                </mask>
                <g mask={`url(#${maskId})`}>
                    <path
                        d="M259.5 119.905C259.5 189.224 203.702 248.5 135 248.5C66.2983 248.5 10.5 189.224 10.5 119.905C10.5002 50.6356 66.2508 -5.50001 135 -5.50001C203.749 -5.5 259.5 50.6357 259.5 119.905Z"
                        fill="#FBF8F4"
                        stroke={`url(#${gradientId})`}
                        strokeWidth="3"
                    />
                </g>
                <path
                    d="M58.5893 113.459L52.932 119.115L47.276 113.459L45.3906 115.344L51.0466 121L45.3906 126.656L47.276 128.542L52.932 122.886L58.5893 128.542L60.4746 126.656L54.8186 121L60.4746 115.344L58.5893 113.459Z"
                    fill="black"
                />
                <defs>
                    <linearGradient
                        id={gradientId}
                        x1="261"
                        y1="121.5"
                        x2="9.00001"
                        y2="121.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#899B30" />
                        <stop offset="0.484375" stopColor="#EDD5C9" />
                        <stop offset="1" stopColor="#D6CFF8" />
                    </linearGradient>
                </defs>
            </svg>
            <button
                type="button"
                className="side-header-menu__mask-close-btn"
                aria-label="Close menu"
                onClick={onClick}
            />
        </div>
    );
}
